var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.35 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 77.5h24v24H16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -4.233 -20.505)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009de6",
    fillRule: "evenodd",
    d: "M40 100.25c0-.23-.045-.459-.132-.672l-1.598-3.871A11.94 11.94 0 0 0 40 89.5c0-6.623-5.377-12-12-12-6.622 0-12 5.377-12 12s5.378 12 12 12c2.27 0 4.395-.632 6.208-1.73l3.87 1.597c.212.088.442.133.672.133.69 0 1.25-.56 1.25-1.25m-12-12a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5.75 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-11.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f5d86e25d22effaa34084934bc9e8f8e.svg";
export { ForwardRef as ReactComponent };